(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["q1-snow"] && !Shopify.designMode) return;
  try {
    
class Snow extends window.HTMLElement {
  constructor() {
    super();
    this.canvas = null;
    this.animationFrame = null;
    this.lastWidth = 0;
    this.resizeTimer = null;
    this.handleResize = this.handleResize.bind(this);
    this.handleVisibility = this.handleVisibility.bind(this);
  }

  connectedCallback() {
    this.img = this.getAttribute("img");
    this.snowNum = this.getAttribute("snowNum");
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const start = () => {
      const run = () => {
        if (!this.isConnected) return;
        this.init();
        window.addEventListener("resize", this.handleResize);
        document.addEventListener("visibilitychange", this.handleVisibility);
      };
      if ("requestIdleCallback" in window) requestIdleCallback(run, { timeout: 3000 });
      else setTimeout(run, 1000);
    };
    if (document.readyState === "complete") start();
    else window.addEventListener("load", start, { once: true });
  }

  init() {
    if (this.canvas) {
      cancelAnimationFrame(this.animationFrame);
      this.canvas.remove();
    }
    const canvas = document.createElement("canvas");
    canvas.setAttribute("id", "snow");
    canvas.setAttribute("aria-hidden", "true");
    canvas.style.position = "fixed";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.width = "100vw";
    canvas.style.height = "100vh";
    canvas.style.zIndex = "100";
    canvas.style.pointerEvents = "none";
    document.body.appendChild(canvas);
    this.canvas = canvas;

    const W = canvas.clientWidth;
    const H = canvas.clientHeight;
    this.lastWidth = window.innerWidth;
    canvas.setAttribute("width", W);
    canvas.setAttribute("height", H);

    const ctx = canvas.getContext("2d");
    const config = {
      number: Math.ceil(W / (101 - +this.snowNum)),
      snowArr: [],
      pic: this.img,
    };

    const snowImg = new Image();
    snowImg.src = config.pic;

    for (let i = 0; i < config.number; i++) {
      config.snowArr.push({
        x: Math.random() * W,
        y: Math.random() * H,
        toX: Math.random(),
        toY: Math.random() * 1 + 1,
        size: Math.random() * 20 + 5,
      });
    }

    const dropAnimation = () => {
      ctx.clearRect(0, 0, W, H);
      for (let i = 0; i < config.snowArr.length; i++) {
        const snow = config.snowArr[i];
        ctx.drawImage(snowImg, snow.x, snow.y, snow.size, snow.size);
        snow.x = snow.x > W ? 0 : snow.x + snow.toX;
        snow.y = snow.y > H ? 0 : snow.y + snow.toY;
      }
      this.animationFrame = requestAnimationFrame(dropAnimation);
    };
    this.dropAnimation = dropAnimation;

    snowImg.onload = () => {
      this.animationFrame = requestAnimationFrame(dropAnimation);
    };
  }

  handleResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      if (window.innerWidth !== this.lastWidth) this.init();
    }, 300);
  }

  handleVisibility() {
    if (document.hidden) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    } else if (this.dropAnimation && !this.animationFrame) {
      this.animationFrame = requestAnimationFrame(this.dropAnimation);
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("visibilitychange", this.handleVisibility);
    clearTimeout(this.resizeTimer);
    if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
    if (this.canvas) this.canvas.remove();
  }
}

if (!customElements.get('ql-snow')) {
  window.customElements.define("ql-snow", Snow);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["time"] && !Shopify.designMode) return;
  try {
    
// 设置展会开始时间：2026年6月22日24时
const countDownDate = new Date("June 22, 2026 24:00:00").getTime();
const x = setInterval(function() {
    const now = new Date().getTime();
    const distance = countDownDate - now;
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    document.getElementById("days").innerHTML = days;
    document.getElementById("hours").innerHTML = hours;
    document.getElementById("minutes").innerHTML = minutes;
    document.getElementById("seconds").innerHTML = seconds;
    if (distance < 0) {
        clearInterval(x);
        document.getElementById("countdown").innerHTML = "The event has started!";
    }
}, 1000);

  } catch(e) { console.error(e); }
})();
})();
